// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-F":"F_power-ocean-collection-F__4RTRa"};